import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function deleteStudent(classId: any, userId: any) {
    const { apiDeleteStudent } = apiConfig.getStaticUrls();

    return postFetch(`${apiDeleteStudent}`, { classId, userId });
}
